import queryString from 'query-string';


const parseAutomaticLogin = (location) => {
    const { automatic_login } = queryString.parse(location.search);
    return automatic_login === '1';
};

export default parseAutomaticLogin;
